export default __webpack_public_path__ + "static/media/blogpost3.6c96fa8b.jpg";